import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import API from "./config/API";

function UserDetails() {
  const { registerId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (registerId) {
      fetchUserData();
    }
  }, [registerId]);

  const fetchUserData = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("user"));

      const res = await axios.get(
        `${API.V1}/user/getUserDataByRegisterId?registerId=${registerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data?.statusCode === 200) {
        setUserData(res.data.data);
      } else {
        alert(res.data?.message || "No Data Found");
      }
    } catch (error) {
      console.error(error);

      if (error.response?.status === 401) {
        alert("Session Expired. Please login again.");

        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
      } else {
        alert("Failed to fetch user details");
      }
    } finally {
      setLoading(false);
    }
  };

  const colors = [
    "#dbeafe",
    "#dcfce7",
    "#fef3c7",
    "#fee2e2",
    "#ede9fe",
    "#cffafe",
  ];

  const fields = [
    { label: "Full Name", value: userData?.fullName },
    { label: "Mobile Number", value: userData?.contactNo },
    { label: "Email ID", value: userData?.emailId },
    { label: "Aadhar Number", value: userData?.aadharCardNo },
    { label: "Floor Name", value: userData?.floorName },
    { label: "Room Name", value: userData?.roomName },
    { label: "Bed Name", value: userData?.userBedName },
    { label: "Staying Type", value: userData?.userStayingType },
    { label: "Bed Status", value: userData?.bedStatus },
    { label: "Payment Type", value: userData?.paymentType },
    {
      label: "Total Bed Cost",
      value: `₹ ${userData?.userBedCost || 0}`,
    },
    {
      label: "Paid Amount",
      value: `₹ ${userData?.userPaidAmount || 0}`,
    },
  ];

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <h2>Loading User Details...</h2>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>👤 User Details</h1>

          <div style={styles.buttonGroup}>
            <button
              style={styles.updateBtn}
              onClick={() => navigate(`/updateUserDetails/${registerId}`)}
            >
              ✏️ Update
            </button>

            <button style={styles.backBtn} onClick={() => navigate(-1)}>
              ← Back
            </button>
          </div>
        </div>

        <div style={styles.grid}>
          {fields.map((field, index) => (
            <div
              key={index}
              style={{
                ...styles.infoCard,
                background: colors[index % colors.length],
              }}
            >
              <div style={styles.label}>{field.label}</div>
              <div style={styles.value}>{field.value || "-"}</div>
            </div>
          ))}
        </div>

        <div
          style={{
            ...styles.paymentStatus,
            background:
              userData?.paymentStatus === "PAID" ? "#dcfce7" : "#fee2e2",
            color: userData?.paymentStatus === "PAID" ? "#15803d" : "#dc2626",
          }}
        >
          Payment Status : {userData?.paymentStatus}
          {userData?.paymentStatus === "PENDING" && (
            <div style={{ marginTop: "12px" }}>
              <button
                style={styles.paymentBtn}
                onClick={() => navigate(`/payment/${registerId}`)}
              >
                Complete Payment →
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserDetails;

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f1f5f9",
    padding: "30px",
  },

  card: {
    maxWidth: "1200px",
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    flexWrap: "wrap",
    gap: "10px",
  },

  title: {
    margin: 0,
    color: "#0f172a",
  },

  buttonGroup: {
    display: "flex",
    gap: "10px",
  },

  updateBtn: {
    border: "none",
    background: "#10b981",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600",
  },

  backBtn: {
    border: "none",
    background: "#2563eb",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: "20px",
  },

  infoCard: {
    borderRadius: "16px",
    padding: "18px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    border: "1px solid rgba(255,255,255,0.5)",
  },

  label: {
    color: "#475569",
    fontSize: "13px",
    marginBottom: "8px",
    fontWeight: "700",
    textTransform: "uppercase",
  },

  value: {
    color: "#0f172a",
    fontWeight: "700",
    fontSize: "17px",
  },

  paymentStatus: {
    marginTop: "25px",
    padding: "18px",
    borderRadius: "12px",
    textAlign: "center",
    fontWeight: "700",
    fontSize: "18px",
  },

  paymentBtn: {
    border: "none",
    background: "#dc2626",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  },

  loadingContainer: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8fafc",
  },
};
